module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMA/wD/AP83WBt9AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAI0lEQVR42mP8//8/AymAiYFEQHsNjKEM9UPdD8NBA+MwSEsAe3EG7IBO9wMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/red_apb.png
// module id = i5Em
// module chunks = 0